export const assessmentKeys = {
  base: ["assessment"] as const,
  detail: (assessmentId: string) => [...assessmentKeys.base, assessmentId] as const,
};
